export default {
  evaluation_list: {
    title: '委託評估企業一覽表',
    number_of_companies_answered: '已回答: {answered}/{total} 公司',
    number_of_companies_displayed: '全部 {total} 件　顯示 {start}〜{end} 件',
    company_name: '公司名稱',
    status: '狀態',
    questionnaire: '問卷',
    plan: '方案',
    nothing: '無符合的企業。',
  },
  evidence_options: {
    all_plan: '所有方案',
    plans_with_vouchers: '有憑證的方案',
    no_voucher_plan: '無憑證的方案',
  },
  table_headers: {
    company_name: '公司名稱',
    status: '狀態',
    esg_rating: 'ESG評級',
    esg_score: 'ESG評分',
    environment: '環境',
    social: '社會',
    governance: '治理',
    plan: '方案',
    questionnaire: '問卷',
    answer_date: '回答日',
    answer_expires_date: '回答期限',
  },
  plan_list: {
    light: '簡易方案',
    starter: '入門方案',
    basic: '基本方案',
    standard: '標準方案',
    enterprize: '企業方案',
  },
}
